module.exports = __webpack_public_path__ + "static/media/Expense-01.b1ca73ff.png";